import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "./logo.svg";
import "./App.css";
import Header from "./components/Header";
import Projects from "./components/Projects";
import ProjectDetails from "./components/ProjectDetails";
import Hero from "./components/Hero";
import ScrollHandler from "./components/ScrollHandler";
import "video.js/dist/video-js.css";

function App() {
  return (
    // <Router basename="/FILES/2025">

    <div className="content">
      <Router>
        <ScrollHandler />

        <Header />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Hero />

                <Projects />
              </>
            }
          />
          <Route path="/projects/:id" element={<ProjectDetails />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
